import { isImportTerminal } from "./AutoImportStatusPanel";

export function startImportStatusPolling({
  workspaceId,
  fetchStatus,
  onStatus,
  onComplete,
  onFailure,
  intervalMs = 3000,
}) {
  let canceled = false;
  let timeoutId = null;
  let controller = null;
  let consecutiveFailures = 0;

  const poll = async () => {
    controller = new AbortController();
    try {
      const status = await fetchStatus(workspaceId, controller.signal);
      if (canceled) return;
      consecutiveFailures = 0;
      onStatus?.(status);
      if (isImportTerminal(status)) {
        onComplete?.(status);
        return;
      }
      timeoutId = window.setTimeout(poll, intervalMs);
    } catch (error) {
      if (canceled) return;
      consecutiveFailures += 1;
      onFailure?.(error, { consecutiveFailures });
      timeoutId = window.setTimeout(poll, Math.min(intervalMs * consecutiveFailures, 10000));
    }
  };

  poll();

  return () => {
    canceled = true;
    controller?.abort();
    if (timeoutId) window.clearTimeout(timeoutId);
  };
}
